import { useCallback } from 'react'
import AluminiumPrimarySmeltingEmissionPointsEditor from '../../../asseEditors/AluminiumPrimarySmeltingEmissionPointsEditor'
import { ProductionRouteAsset } from '@/features/production-routes/api/ProductionRouteModel'
import useAsssetInstances from '../../../asseEditors/useAssetInstances'
import AluminiumSecondaryMeltingEmissionPointsEditor from '../../../asseEditors/AluminiumSecondaryMeltingEmissionPointsEditor'
import AluminiumProductsEmissionPointsEditor from '../../../asseEditors/AluminiumProductsEmissionPointsEditor'
import CementEmissionPointsEditor from '../../../asseEditors/components/CementEmissionPointsEditor'
import IronOrSteelProductsEmissionPointsEditor from '@/features/production-routes/asseEditors/IronOrSteelProductsEmissionPointsEditor'
import CementClinkerEmissionPointsEditor from '@/features/production-routes/asseEditors/components/CementClinkerEmissionPointsEditor'

export default function ProductionRouteAssets({
  next,
  previous,
  assets,
  productionMethodCode
}: {
  next: (selectedAssets: ProductionRouteAsset[]) => void
  previous: () => void
  assets: ProductionRouteAsset[]
  productionMethodCode: string
}) {
  const {
    selectedAssets,
    addAssetWithId,
    removeAssetWithId,
    updateAssetWithId,
    removeMultipleAssets
  } = useAsssetInstances(assets)

  const onNextClick = useCallback(() => {
    next(selectedAssets)
  }, [next, selectedAssets])

  const onPreviousClick = useCallback(() => {
    previous()
  }, [previous])

  const isCement =
    productionMethodCode === 'P01' ||
    productionMethodCode === 'P03' ||
    productionMethodCode === 'P04'

  const isCementClinker = productionMethodCode === 'P02'

  return (
    <div className="space-y-4">
      {productionMethodCode === 'P42' && (
        <AluminiumPrimarySmeltingEmissionPointsEditor
          selectedAssets={selectedAssets}
          addAssetWithId={addAssetWithId}
          removeAssetWithId={removeAssetWithId}
          updateAssetWithId={updateAssetWithId}
          removeMultipleAssets={removeMultipleAssets}
          onPreviousClick={onPreviousClick}
          onNextClick={onNextClick}
        />
      )}
      {productionMethodCode === 'P43' && (
        <AluminiumSecondaryMeltingEmissionPointsEditor
          selectedAssets={selectedAssets}
          addAssetWithId={addAssetWithId}
          removeAssetWithId={removeAssetWithId}
          updateAssetWithId={updateAssetWithId}
          removeMultipleAssets={removeMultipleAssets}
          onPreviousClick={onPreviousClick}
          onNextClick={onNextClick}
        />
      )}
      {productionMethodCode === 'P45' && (
        <AluminiumProductsEmissionPointsEditor
          selectedAssets={selectedAssets}
          addAssetWithId={addAssetWithId}
          removeAssetWithId={removeAssetWithId}
          updateAssetWithId={updateAssetWithId}
          removeMultipleAssets={removeMultipleAssets}
          onPreviousClick={onPreviousClick}
          onNextClick={onNextClick}
        />
      )}
      {productionMethodCode === 'P34' && (
        <IronOrSteelProductsEmissionPointsEditor
          selectedAssets={selectedAssets}
          addAssetWithId={addAssetWithId}
          removeAssetWithId={removeAssetWithId}
          updateAssetWithId={updateAssetWithId}
          removeMultipleAssets={removeMultipleAssets}
          onPreviousClick={onPreviousClick}
          onNextClick={onNextClick}
        />
      )}
      {isCement && (
        <CementEmissionPointsEditor
          selectedAssets={selectedAssets}
          addAssetWithId={addAssetWithId}
          removeAssetWithId={removeAssetWithId}
          updateAssetWithId={updateAssetWithId}
          removeMultipleAssets={removeMultipleAssets}
          onPreviousClick={onPreviousClick}
          onNextClick={onNextClick}
        />
      )}
      {isCementClinker && (
        <CementClinkerEmissionPointsEditor
          selectedAssets={selectedAssets}
          addAssetWithId={addAssetWithId}
          removeAssetWithId={removeAssetWithId}
          updateAssetWithId={updateAssetWithId}
          removeMultipleAssets={removeMultipleAssets}
          onPreviousClick={onPreviousClick}
          onNextClick={onNextClick}
        />
      )}
    </div>
  )
}
